import { ServiceProviderProps } from "@citychallenge/core";
import { useMemo } from "react";

import { WEB_CONFIG } from "../web-config";
import { DeviceAdapter } from "./device.adapter";
import { FSAdapter } from "./fs.adapter";
import { getStorage } from "./get-storage";
import { IAPAdapter } from "./iap.adapter";
import { LoginAdapter } from "./login.adapter";
import { NetInfoAdapter } from "./net-info.adapter";
import { PermissionsAdapter } from "./permission.adapter";
import { PushAdapter } from "./push.adapter";

export interface MobileServiceProviderProps {
  servicesReady?: () => void;
}

export const useAdapters = () => {
  return useMemo<ServiceProviderProps["adapters"]>(() => {
    return {
      appState: {
        currentState: "active",
        addEventListener: () => null,
        removeEventListener: () => null,
      },
      device: new DeviceAdapter(),
      fs: new FSAdapter(),
      geolocation: {
        getCurrentPosition: () => undefined,
        stopObserving: () => undefined,
      },
      iap: new IAPAdapter(),
      login: LoginAdapter,
      netinfo: new NetInfoAdapter(),
      push: new PushAdapter(),
      permission: new PermissionsAdapter(),
      storage:
        WEB_CONFIG.STORAGE_TYPE === "persistent"
          ? getStorage("localStorage")
          : getStorage("sessionStorage"),
      secureStorage:
        WEB_CONFIG.STORAGE_TYPE === "persistent"
          ? getStorage("localStorage")
          : getStorage("sessionStorage"),
    };
  }, []);
};
